// extracted by mini-css-extract-plugin
export default {"statuses":"DeviceStatusBox_statuses__b7wIG","singleStatus":"DeviceStatusBox_singleStatus__FCI8m"};